module.exports = __webpack_public_path__ + "static/pinkfairy3-76c7a62451360a0da92ada26fd884c04.png";